// extracted by mini-css-extract-plugin
module.exports = {"FaQItem":"style_FaQItem__nEokp","FaQItemQuestion":"style_FaQItemQuestion__0O_2O","FaQItemAnswer":"style_FaQItemAnswer__8Bv2d"};